import { render, staticRenderFns } from "./flickity-alt-buttons.vue?vue&type=template&id=8f6d25ca&scoped=true&"
import script from "./flickity-alt-buttons.vue?vue&type=script&lang=js&"
export * from "./flickity-alt-buttons.vue?vue&type=script&lang=js&"
import style0 from "./flickity-alt-buttons.vue?vue&type=style&index=0&id=8f6d25ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6d25ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f6d25ca')) {
      api.createRecord('8f6d25ca', component.options)
    } else {
      api.reload('8f6d25ca', component.options)
    }
    module.hot.accept("./flickity-alt-buttons.vue?vue&type=template&id=8f6d25ca&scoped=true&", function () {
      api.rerender('8f6d25ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/flickity-alt-buttons.vue"
export default component.exports